export const headerHeight = {
  xs: 60,
  md: 60,
  lg: 72,
};

export const breakpoints = {
  xs: 360,
  sm: 600,
  md: 1024,
  lg: 1280,
  xl: 1440,
};

export const spacing = 8;
